import { Section, SectionParagraph, SectionTitle } from '@/components/shared/Content';
import JoinCTA from '@/components/shared/JoinCTA';
import starsConfiguration from '@/static/pet/stars.json';
import { Flex, ResponsiveBreak, useLottie } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import { useRef } from 'react';
import styled from 'styled-components';
import { PetLandingPageType } from '../shared';
import StoriesCarousel from './StoriesCarousel';

const ReviewsWrapper = styled(Section)`
  width: 100%;
  background-color: #fbfbfb;
`;

const Heading = styled(SectionTitle)`
  margin-bottom: 24px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        margin-bottom: 16px;
    `}
`;

const SubHeading = styled(SectionParagraph)`
  margin-bottom: 24px;
  width: 90%;

  ${MEDIA_QUERIES.tabletAndDesktop`
        margin-bottom: 48px;
        width: initial;
    `}
`;

export const MainCTA = styled(JoinCTA)`
  width: 265px;
  margin-bottom: 24px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        margin-bottom: 48px;
    `}
`;

const Stars = styled(Flex)`
  width: 330px;
  height: 68px;
  margin-bottom: 48px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        width: 792px;
        height: 155px;
        margin-bottom: 80px;
    `}
`;

const TOP_RATED_TYPE = {
  [PetLandingPageType.Dog]: 'Dog',
  [PetLandingPageType.Cat]: 'Feline',
  [PetLandingPageType.PetInsurance]: 'Pet',
};

interface ReviewsProps {
  petLandingPageType: PetLandingPageType;
}

const Reviews: React.FC<ReviewsProps> = ({ petLandingPageType }) => {
  const starsRef = useRef(null);

  useLottie(starsRef, {
    animationData: starsConfiguration,
    lottieConfig: {
      loop: false,
    },
    scrollOptions: {
      playTrigger: {
        threshold: 0.3,
        condition: 'contain',
        pauseIfConditionsUnmet: true,
      },
    },
  });
  return (
    <ReviewsWrapper justifyContent="center" pt={[40, 70]}>
      <Flex flexDirection="column" alignItems="center" px={[16, 16, 0]}>
        <Heading>
          America’s Top-Rated Insurance,
          <ResponsiveBreak display={['block', 'block']} />
          Now for Your&nbsp;
          {TOP_RATED_TYPE[petLandingPageType][0].toUpperCase() + TOP_RATED_TYPE[petLandingPageType].slice(1)}
        </Heading>
        <SubHeading>
          Lemonade has earned 4.9 stars in the App
          <ResponsiveBreak display={['inline', 'inline']} />
          store and on Google Play,
          <ResponsiveBreak display={['inline', 'block']} />
          and is top-rated by Supermoney, Clearsurance, and others
        </SubHeading>
      </Flex>
      <Stars ref={starsRef} />
      <StoriesCarousel petLandingPageType={petLandingPageType} />
    </ReviewsWrapper>
  );
};

export default Reviews;
